module.exports = __webpack_public_path__ + "static/media/watermark-textresume.78fcb1a3.jpeg";